import React, { useCallback, ReactElement, useContext } from 'react';

import { CalciteButton, CalciteList } from '@esri/calcite-components-react';

import operators from '../../data/operators';
import FilterItem from './FilterItem';
import FilterContext from '../../contexts/FilterContext';

interface Props {
  colDefs: TypedColumn[];
}

export default function FilterManager({ colDefs }: Props): ReactElement {
  const [filters, updateFilters] = useContext(FilterContext);

  // Update filter at index
  const updateFilterItem = useCallback(
    (idx: number, newFilter: DataFilter) => {
      console.log('updateFilterItem', idx, newFilter);
      const filtersCopy = [...filters];
      filtersCopy[idx] = newFilter;
      updateFilters(filtersCopy);
    },
    [filters, updateFilters]
  );

  // Remove filter at index
  const deleteFilterItem = useCallback(
    (idx: number) => {
      const filtersCopy = [...filters];
      filtersCopy.splice(idx, 1);
      updateFilters(filtersCopy);
    },
    [filters, updateFilters]
  );

  // Add a new filter item to the column
  const createNewFilter = useCallback(() => {
    const column = colDefs[0];
    // If there are no filters, just add one
    const emptyFilter: DataFilter = {
      field: column.field.name,
      value: '',
      join: 'AND',
      operator: operators[column.filterType][0],
    };

    // Update filters
    const filtersCopy = [...filters];
    filtersCopy.push(emptyFilter);
    updateFilters(filtersCopy);
  }, [colDefs, filters, updateFilters]);

  return (
    <div>
      {/* Display existing filters */}

      <CalciteList>
        {filters &&
          filters.map((filter, idx) => (
            <div key={idx}>
              {/* Display the join options (only if there are multiple filters) */}
              {/* {idx !== 0 ? (
              <FilterItemJoin
                join={filter.join}
                onJoinChange={(newJoin) =>
                  updateFilterItem(idx, { ...filter, join: newJoin })
                }
              />
            ) : null} */}
              {/* Display the actual filter information */}
              <FilterItem
                filter={filter}
                onFilterChange={(newFilter) => updateFilterItem(idx, newFilter)}
                onDeleteFilter={() => deleteFilterItem(idx)}
                colDefs={colDefs}
                onFieldChange={(field, fieldType) =>
                  updateFilterItem(idx, {
                    ...filter,
                    field,
                    operator: operators[fieldType][0],
                  })
                }
              />
            </div>
          ))}
      </CalciteList>

      {/* Create new filter button */}
      <div className="flex justify-center">
        <CalciteButton
          label="Add filter"
          onClick={createNewFilter}
          iconStart="plus"
          className="p-4"
        >
          Add Filter
        </CalciteButton>
      </div>
    </div>
  );
}
